import { CSVProfile, CSVTranformationProfile } from '../../types'
import { MwChartDonutChartOptions, SeriesData } from '@meltwater/mw-visualizations-angularjs'

import { BaseVisualization } from '../base/base-visualization-component'
import round from 'lodash/round'

export class DonutChartComponent extends BaseVisualization {
 static config = {
  selector: 'afDonutChart',
  controller: DonutChartComponent,
  template: `
            <mw-chart-donut
                ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationData)"
                chart-data="$ctrl.visualizationData"
                chart-options="$ctrl.visualizationOptions"
                get-api="$ctrl.getApi(API)">
            </mw-chart-donut>
        `,
  bindings: BaseVisualization.config.bindings,
 }

 public vizData
 public seriesName: string = this.visTitle || 'Sentiment'
 public seriesColors
 public seriesData
 public areDataLabelsVisible: boolean = false
 public showLegend: boolean = false
 public error: boolean

 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Category', 'Count']
 public transformationProfiles: CSVTranformationProfile[] = []

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (changes.vizData && typeof changes.vizData.currentValue !== 'undefined') {
   if (!this.isObjEmpty(changes.vizData.currentValue.data)) {
    this.setProperties()
    this.updateData(changes.vizData.currentValue.data)
    this.updateOptions()
    this.buildCSVExportProfile()
   } else {
    this.visualizationData = {}
   }
  }
 }

 setProperties() {}

 updateData(data) {
  this.visualizationData = new SeriesData({
   name: this.seriesName,
   data: this.seriesData,
  })
 }

 onPointClick = ({ sliceName }) => {
  this.triggerUpdate(
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'sentiment',
    this.labelUtils.getSentimentType(sliceName)
   )
  )
 }

 dataLabelFormatter = options => `${options.key}: ${this.numberFormatter(options.percentage)}%`

 tooltipFormatter = options => `${options.sliceName}: ${this.numberFormatter(options.percentage)}%`

 updateOptions() {
  this.visualizationOptions = new MwChartDonutChartOptions({
   seriesColors: this.seriesColors,
   areDataLabelsVisible: this.areDataLabelsVisible,
   showLegend: this.showLegend,
   dataLabelFormatter: this.dataLabelFormatter,
   tooltipFormatter: this.tooltipFormatter,
   ...(this.isChartClickable() ? { onPointClick: this.onPointClick } : undefined),
  })
 }

 numberFormatter(num) {
  return round(num, 1);
 }

 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}
